import {
  DP_LIST, DP_LIST_SUCCESS, DP_LIST_ERROR, DP_PAGE_SET,
  DP_UPDATE, DP_UPDATE_SUCCESS, DP_UPDATE_ERROR,
  DP_FILTER_SUPPLIERS_SUCCESS,
  DP_FILTER_ACQUISITION_DETAILS_SUCCESS,
  DP_FILTER_DESTINATIONS_SUCCESS,
  DP_FILTER_DISBURSEMENTS_SUCCESS,
  DP_SEARCH_CHANGE,
  DELIVERY_PLAN_TASK_UPDATE, DELIVERY_PLAN_TASK_UPDATE_SUCCESS, DELIVERY_PLAN_TASK_UPDATE_ERROR
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'id_delivery_plan', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  edit: { update: { loading: false, response: '', message: '' } },
  search: { data: { supplier: '', acquisition_detail: '', destination: '', disbursement: '', is_ready_for_inspection: '' } },
  filters: { suppliers: [], acquisition_details: [], destinations: [], disbursements: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DP_LIST: return { ...state, loading: true };
    case DP_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case DP_LIST_ERROR: return { ...state, loading: false, error: true };
    case DP_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case DP_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case DP_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case DP_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    case DP_FILTER_SUPPLIERS_SUCCESS: return { ...state, filters: { ...state.filters, suppliers: action.payload } };
    case DP_FILTER_ACQUISITION_DETAILS_SUCCESS: return { ...state, filters: { ...state.filters, acquisition_details: action.payload } };
    case DP_FILTER_DESTINATIONS_SUCCESS: return { ...state, filters: { ...state.filters, destinations: action.payload } };
    case DP_FILTER_DISBURSEMENTS_SUCCESS: return { ...state, filters: { ...state.filters, disbursements: action.payload } };
    case DP_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };
    case DELIVERY_PLAN_TASK_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case DELIVERY_PLAN_TASK_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case DELIVERY_PLAN_TASK_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    default: return { ...state };
  }
};
